import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SendbackPromptCardProps {
  emoji: string;
  message: string;
  onAction: () => void;
  onDismiss: () => void;
  className?: string;
}

export const SendbackPromptCard: React.FC<SendbackPromptCardProps> = ({
  emoji,
  message,
  onAction,
  onDismiss,
  className,
}) => {
  return (
    <div 
      className={cn(
        "bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg p-3 border border-primary/20",
        className
      )}
    >
      <div className="flex items-start gap-2">
        <span className="text-lg flex-shrink-0">{emoji}</span>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-muted-foreground leading-relaxed">
            {message}
          </p>
          <Button
            variant="ghost"
            size="sm"
            onClick={onAction}
            className="text-xs text-primary hover:text-primary h-6 px-0 mt-1"
          >
            Do it now
            <ArrowRight className="h-3 w-3 ml-1" />
          </Button>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={onDismiss}
          className="h-5 w-5 flex-shrink-0 text-muted-foreground hover:text-foreground"
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
};
